import { PagedSearch } from '../../model/paged-search.model';
import { PagedResult } from '../../model/paged-result.model';
import { LazyLoadEvent } from 'primeng/api';
import { Table as DataTable } from 'primeng/table';

export interface IDatagridService {
  applyPagingDefaults(dataGrid: DataTable, params: any): void;
  getPagedSearchFromDataGridEvent(event: LazyLoadEvent): PagedSearch;
  mapPagedSearchToParams(pagedSearch: PagedSearch, params: any): any;
  mapPagedResultToParams(pagedResult: PagedResult, params: any): any;

  //***depreciated***
  mapDatagridPagingToPagedSearch(dataGridPagingEvent: any, pagedParam: any): any;
  mapPagedResultsToPagedSearch(pagedResult: PagedResult, param: any): void;
}
